import { render } from "./customerStatistics.vue?vue&type=template&id=564bfdfb"
import script from "./customerStatistics.vue?vue&type=script&lang=js"
export * from "./customerStatistics.vue?vue&type=script&lang=js"

import "./customerStatistics.vue?vue&type=style&index=0&id=564bfdfb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__